import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="inicio" className="relative w-full min-h-screen flex flex-col items-center pt-28 pb-20 px-4 overflow-hidden bg-transparent" data-id="element-156">
      {/* Background Glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-gradPurple/10 blur-[150px] rounded-full pointer-events-none" data-id="element-157" />

      <div className="max-w-5xl mx-auto w-full flex flex-col items-center text-center z-10" data-id="element-158">
        <motion.div initial="hidden" animate="visible" variants={{
        visible: {
          transition: {
            staggerChildren: 0.1
          }
        }
      }} className="flex flex-col items-center w-full" data-id="element-159">
          {/* Main Title */}
          <motion.h1 variants={itemVariants} className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-8 leading-[1.1] tracking-tight" data-id="element-160">
            Dominá tu cursada
            <br data-id="element-161" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gradOrange via-gradPink to-gradPurple" data-id="element-162">
              SIN ESTRÉS
            </span>
            <br data-id="element-163" />
            desde el primer día
          </motion.h1>

          {/* Sub Title Block */}
          <motion.div variants={itemVariants} className="flex flex-col items-center mb-6" data-id="element-164">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-165">
              MegaPack
            </h2>
            <h3 className="text-3xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-gradOrange to-gradPink" data-id="element-166">
              Cursada Sin Estrés
            </h3>
          </motion.div>

          {/* Pill */}
          <motion.div variants={itemVariants} className="bg-gradient-to-r from-[#FF5E00] to-[#FFB300] rounded-full px-8 py-1.5 md:py-2 mb-4 shadow-[0_0_40px_rgba(255,150,0,0.9)] border border-[#FFB300]/80" data-id="element-167">
            <span className="text-[#0B0813] font-black text-xs sm:text-sm md:text-base tracking-widest whitespace-nowrap" data-id="element-168">
              5 TOMOS + 3 BONOS + IMPRIMIBLES
            </span>
          </motion.div>

          {/* Subtitle */}
          <motion.p variants={itemVariants} className="text-lg md:text-xl text-textMuted max-w-2xl mb-2 font-medium" data-id="element-169">
            Un sistema completo para estudiar, organizarte y rendir mejor.
          </motion.p>

          {/* Image */}
          <motion.div variants={itemVariants} className="relative w-full max-w-[800px] mx-auto mb-12 -mt-6 md:-mt-10" data-id="element-170">
            <img src="https://cdn.magicpatterns.com/uploads/w68Haj1LUqSxmYtLY6sdnX/Mockup_final_MegaPack_cursada_sin_estres_-_Editado.png" alt="MegaPack Cursada Sin Estrés" className="w-full h-auto object-contain drop-shadow-[0_0_50px_rgba(138,43,226,0.2)] pt-[-100px] pb-[-100px] mt-[-100px] mb-[-100px]" data-id="element-171" />
          </motion.div>

          {/* Lower CTA Area */}
          <motion.div variants={itemVariants} className="flex flex-col items-center w-full max-w-3xl relative" data-id="element-172">
            <div className="flex items-center justify-center gap-6 mb-10" data-id="element-173">
              <div className="border border-gradOrange/50 text-gradOrange px-6 py-2 rounded-full font-bold text-sm md:text-base tracking-widest bg-gradOrange/10" data-id="element-174">
                EDICIÓN COMPLETA 2026
              </div>
              <div className="bg-gradOrange text-white font-black w-20 h-20 rounded-full flex items-center justify-center text-center shadow-[0_0_20px_rgba(255,107,0,0.5)] text-[14px]" data-id="element-175">
                50%
                <br data-id="element-176" />
                OFF
              </div>
            </div>

            <p className="text-xl md:text-2xl text-white font-medium mb-10 max-w-2xl leading-relaxed" data-id="element-177">
              Organizá materias, parciales y entregas desde el primer día.{' '}
              <br data-id="element-178" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00E676] to-[#00B0FF] font-bold" data-id="element-179">
                Sin improvisar más.
              </span>
            </p>

            <a href="https://checkout.infinita-mente.online/checkouts/cn/hWN9hJcYAJ6aX5aJ3wBC1CQj/es-ar?_r=AQAB8bH0zu89K7bsPll58nLRDWhvvq0TO43BcpK3J-clHp8&preview_theme_id=138558668898" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-[#10B981] to-[#047857] hover:from-[#059669] hover:to-[#065f46] text-white font-black text-xl md:text-2xl px-8 py-3 rounded-full transition-all duration-300 mb-8 w-full md:w-auto inline-block text-center no-underline hover:scale-105 shadow-[0_0_15px_rgba(16,185,129,0.3)] whitespace-nowrap" data-id="element-180">
              Quiero el MegaPack
            </a>

            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 text-xs md:text-sm font-medium text-textMuted" data-id="element-181">
              <span className="flex items-center gap-2" data-id="element-182">
                <span className="text-white/50" data-id="element-183">📄</span> 100% PDF
              </span>
              <span className="flex items-center gap-2" data-id="element-184">
                <span className="text-white/50" data-id="element-185">⚡</span> Acceso inmediato
              </span>
              <span className="flex items-center gap-2" data-id="element-186">
                <span className="text-white/50" data-id="element-187">🛡️</span> Garantía 7 días
              </span>
              <span className="flex items-center gap-2" data-id="element-188">
                <span className="text-white/50" data-id="element-189">💳</span> Mercado Pago
              </span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}